import { render } from "./step-home.vue?vue&type=template&id=985139e8"
import script from "./step-home.vue?vue&type=script&lang=js"
export * from "./step-home.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matthiasswiercz/PhpstormProjects/sksturm/custom/plugins/SkSturmTheme/src/Resources/app/storefront/srcVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__